export const labelJwt: string = 'slender-jwt';